import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/mixcloud': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M424.4 219.7c42.4 9.1 74.5 47.1 74.5 92.2 0 52.3-42.6 94.7-95 94.7h-289.6c-62.6 0-113.2-50.7-113.2-113 0-56.8 42.1-103.6 96.6-111.6 23-67.6 86.9-114.1 159.2-114.1 87.2 0 159.2 66.7 167.5 151.7zM403.9 364.3c29.1 0 52.6-23.5 52.6-52.3 0-22.1-14.1-41-33.5-48.5-1.4 8.6-3.6 17.2-6.4 25.5-8 25.6-49.1 14.2-40.1-13.3 4.2-12.7 6.4-26 6.4-39.6 0-69.2-56.5-125.7-126-125.7-49.8 0-94.7 29.6-114.6 73.9 19.4 5 37.4 15 52.1 29.3 20 20-10.2 50.1-30.2 30.2-13.3-13.3-31-20.8-49.8-20.8-39 0-70.9 31.6-70.9 70.6s31.8 70.6 70.9 70.6h289.6zM639 311.9c0 44-12.7 86.4-37.1 122.7-4.2 6.1-10.8 9.4-17.7 9.4-16.3 0-27.1-18.8-17.4-32.9 19.4-29.3 29.9-63.7 29.9-99.1 0-35.4-10.5-69.8-29.9-98.8-15.7-22.8 19.4-47.2 35.2-23.5 24.4 36 37.1 78.4 37.1 122.4zM568.1 311.9c0 31.6-9.1 62-26.9 88.3-4.2 6.1-10.8 9.1-17.7 9.1-17.2 0-27-19-17.4-32.9 13-19.1 19.7-41.3 19.7-64.5 0-23-6.6-45.4-19.7-64.5-15.8-23 19-47.1 35.2-23.5 17.7 26 26.9 56.5 26.9 88z'
      }
    ]
  }
})
